export enum ContentType {
    default,
    blank,
    toBeImproved,
    good,
    excellent,
    repeat,
    omit,
    pause,
    prompt,
    error
}

export enum StudyType {
    听,
    学,
    读,
    背,
}

export enum ReciteType {
    隔句背诵,
    随机掏空,
    只看首字,
    不看课文,
}

export enum ReportType {
    读 = 1,
    背,
}

export enum correctionTypeEnum{
  normal, // 普通
  mental=7 // 口算
}

export enum showTypeEnum{
  score = 1, // 分值
  level, // 等级
  scoreAndLevel, // 分值和等级
}

export enum dimensionsTypeEnum{
  score = 1, // 分值
  level, // 等级
}
export enum levelTypeEnum{
  excellent = 1, // 优
  good, // 良
  pass, // 及格
  fail, // 不及格
}

export enum writeModuleEnum {
  comprehensive = 1,
  commentSentences,
  articlePolish,
  materialSample,
}

export enum MissonTypeEnum {
  sign = 23001,
  sign1 = 23002,
  sign2 = 23003,
  sign7 = 23004,
  sign14 = 23005,
  report = 23006,
  welfare = 23007,
  community = 23008,
  lessons = 23009,
  video = 23010,
  community_20 = 23011,
  coin_mall = 23012,
  material_20 = 23013,
  qingying_20 = 23014,
  listen_20 = 23015,
  share = 23016,
  cake = 23017,
  draw = 23018,
}